"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLowestRates = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _api = require("@whitbread-eos/api");
var _utils = require("@whitbread-eos/utils");
var _nextI18next = require("next-i18next");
var _react = require("react");
var _helpers = require("../helpers");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useLowestRates = exports.useLowestRates = function useLowestRates(criteria, currentDates) {
  var _data$getLowestRatesB;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var locationName = arguments.length > 3 ? arguments[3] : undefined;
  var {
    enabled = true
  } = options;
  var {
    t
  } = (0, _nextI18next.useTranslation)();
  var defaultLocationName = t('priceFinder.MVP.customConfig.defaultLocationName');
  var {
    data,
    isLoading,
    isError,
    isFetching,
    refetch
  } = (0, _utils.useQueryRequest)(['lowestRatesByLocationId', criteria.locationId, criteria.arrival, criteria.sortBy, criteria.sortDate, criteria.page, criteria.initialPageSize, criteria.lazyLoadPageSize], _api.GET_LOWEST_RATES_BY_LOCATION_ID, {
    criteria
  }, {
    enabled: enabled && !!criteria.locationId
  });
  var monthSelected = new Date(currentDates[0]);
  var numberOfSoldOutResults = data === null || data === void 0 || (_data$getLowestRatesB = data.getLowestRatesByLocationId) === null || _data$getLowestRatesB === void 0 ? void 0 : _data$getLowestRatesB.priceFinderOperaHotelAvailabilitiesDtoList.filter(hotel => {
    var _hotel$availabilities, _hotel$availabilities2;
    return ((_hotel$availabilities = (_hotel$availabilities2 = hotel.availabilities) === null || _hotel$availabilities2 === void 0 ? void 0 : _hotel$availabilities2.length) !== null && _hotel$availabilities !== void 0 ? _hotel$availabilities : 0) === 0;
  });
  var renderCount = (0, _react.useRef)(0);
  var previousCriteria = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    if (!criteria.locationId) return;
    var criteriaHasChanged = previousCriteria.current && JSON.stringify(previousCriteria.current) !== JSON.stringify(criteria);
    _utils.analytics === null || _utils.analytics === void 0 || _utils.analytics.update({
      searchResults: {
        priceFinder: {
          searchLocation: locationName !== null && locationName !== void 0 ? locationName : defaultLocationName,
          defaultLocation: !criteriaHasChanged,
          defaultDate: !criteriaHasChanged,
          monthSelected: monthSelected.toLocaleString('en-GB', {
            month: 'long'
          }),
          weekSelected: currentDates,
          pageNumber: criteria.page,
          sortBy: criteria.sortBy
        }
      }
    });
    renderCount.current += 1;
    previousCriteria.current = _objectSpread({}, criteria);
  }, [criteria]);
  (0, _react.useEffect)(() => {
    var _window, _data$getLowestRatesB2, _data$getLowestRatesB3, _numberOfSoldOutResul;
    _utils.analytics === null || _utils.analytics === void 0 || _utils.analytics.update({
      searchResults: {
        priceFinder: _objectSpread(_objectSpread({}, (_window = window) === null || _window === void 0 || (_window = _window.analyticsData) === null || _window === void 0 || (_window = _window.searchResults) === null || _window === void 0 ? void 0 : _window.priceFinder), {}, {
          numberOfResults: (_data$getLowestRatesB2 = data === null || data === void 0 || (_data$getLowestRatesB3 = data.getLowestRatesByLocationId) === null || _data$getLowestRatesB3 === void 0 || (_data$getLowestRatesB3 = _data$getLowestRatesB3.priceFinderOperaHotelAvailabilitiesDtoList) === null || _data$getLowestRatesB3 === void 0 ? void 0 : _data$getLowestRatesB3.length) !== null && _data$getLowestRatesB2 !== void 0 ? _data$getLowestRatesB2 : 0,
          numberOfSoldOutResults: (_numberOfSoldOutResul = numberOfSoldOutResults === null || numberOfSoldOutResults === void 0 ? void 0 : numberOfSoldOutResults.length) !== null && _numberOfSoldOutResul !== void 0 ? _numberOfSoldOutResul : 0
        })
      }
    });
  }, [data]);
  var hotelData = (0, _react.useMemo)(() => {
    var _data$getLowestRatesB4;
    if (!(data !== null && data !== void 0 && (_data$getLowestRatesB4 = data.getLowestRatesByLocationId) !== null && _data$getLowestRatesB4 !== void 0 && _data$getLowestRatesB4.priceFinderOperaHotelAvailabilitiesDtoList)) {
      return [];
    }
    var apiData = data.getLowestRatesByLocationId.priceFinderOperaHotelAvailabilitiesDtoList;
    return (0, _helpers.transformApiDataToHotelPrices)(apiData, currentDates);
  }, [data, currentDates]);
  var globalLowestPrice = (0, _react.useMemo)(() => {
    var _data$getLowestRatesB5;
    return (data === null || data === void 0 || (_data$getLowestRatesB5 = data.getLowestRatesByLocationId) === null || _data$getLowestRatesB5 === void 0 || (_data$getLowestRatesB5 = _data$getLowestRatesB5.lowestMonthlyRate) === null || _data$getLowestRatesB5 === void 0 ? void 0 : _data$getLowestRatesB5.price) || null;
  }, [data]);
  return {
    data: data || null,
    hotelData,
    globalLowestPrice,
    isLoading,
    isError,
    isFetching,
    refetch
  };
};